import { jsx as _jsx } from "react/jsx-runtime";
const TransactionTitle = ({ title }) => {
    return (_jsx("div", { className: "transaction__title", children: _jsx("h3", { className: "title-text", children: title }) }));
};
export default TransactionTitle;
